<template>
	<div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table :columns="defaultColumns" :data="datas" ref="table" >
				<template slot-scope="{ row,index }" slot="gjj">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_gjj_form_num >= row.gjj_form_num)&&row.gjj_form_num != 0}">
						<div :class="{'second': (row.current_gjj_form_num >= row.gjj_form_num)&&row.gjj_form_num != 0}">

							<span ><span
									v-if="row.current_gjj_form_num >= 0 &&row.gjj_form_num != 0">{{row.current_gjj_form_num}}/</span><span
									v-if="row.gjj_form_num == 0">
									<Icon type="md-close" style="color: red;" size="30" />
								</span><span v-if="row.gjj_form_num != 0">{{row.gjj_form_num}}</span></span>
						</div>
						<div v-if="checkThreePlusStatus == true">
							<span
								:class="{'check-threeplus-false':row.current_gjj_form_num < row.gjj_form_num,'check-threeplus-true': (row.current_gjj_form_num >= row.gjj_form_num)&&row.gjj_form_num != 0}"><span v-if="row.gjj_zonghe_form_num > 0 &&row.gjj_form_num == 0">{{row.current_gjj_form_num}}/</span>{{row.current_gjj_threeplus}}</span>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].gjj_form_cost">
						</Input>
						<span v-if="editStatus ==0">{{row.gjj_form_cost}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="fangdi">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_fangdi_form_num >= row.fangdi_form_num)&&row.fangdi_form_num != 0}">
						<div
							:class="{'second': (row.current_fangdi_form_num >= row.fangdi_form_num)&&row.fangdi_form_num != 0}">

							<span ><span
									v-if="row.current_fangdi_form_num >= 0 &&row.fangdi_form_num != 0">{{row.current_fangdi_form_num}}/</span><span
									v-if="row.fangdi_form_num == 0">
									<Icon type="md-close" style="color: red;" size="30" />
								</span><span v-if="row.fangdi_form_num != 0">{{row.fangdi_form_num}}</span></span>
						</div>
						<div v-if="checkThreePlusStatus == true">
							<span
								:class="{'check-threeplus-false':row.current_fangdi_form_num < row.fangdi_form_num,'check-threeplus-true': (row.current_fangdi_form_num >= row.fangdi_form_num)&&row.fangdi_form_num != 0}"><span v-if="row.current_fangdi_form_num > 0 &&row.fangdi_form_num == 0">{{row.current_fangdi_form_num}}/</span>{{row.current_fangdi_threeplus}}</span>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].fangdi_form_cost">
						</Input>
						<span v-if="editStatus ==0">{{row.fangdi_form_cost}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="chedi">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_chedi_form_num >= row.chedi_form_num)&&row.chedi_form_num != 0}">

						<span ><span
								v-if="row.current_chedi_form_num >= 0 &&row.chedi_form_num != 0">{{row.current_chedi_form_num}}/</span><span
								v-if="row.chedi_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.chedi_form_num != 0">{{row.chedi_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<span
								:class="{'check-threeplus-false':row.current_chedi_form_num < row.chedi_form_num,'check-threeplus-true': (row.current_chedi_form_num >= row.chedi_form_num)&&row.chedi_form_num != 0}"><span v-if="row.current_chedi_form_num > 0 &&row.chedi_form_num == 0">{{row.current_chedi_form_num}}/</span>{{row.current_chedi_threeplus}}</span>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].chedi_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.chedi_form_cost}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="qiye">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_qiye_form_num >= row.qiye_form_num)&&row.qiye_form_num != 0}">

						<span ><span
								v-if="row.current_qiye_form_num >= 0 &&row.qiye_form_num != 0">{{row.current_qiye_form_num}}/</span><span
								v-if="row.qiye_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.qiye_form_num != 0">{{row.qiye_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<span
								:class="{'check-threeplus-false':row.current_qiye_form_num < row.qiye_form_num,'check-threeplus-true': (row.current_qiye_form_num >= row.qiye_form_num)&&row.qiye_form_num != 0}"><span v-if="row.current_qiye_form_num > 0 &&row.qiye_form_num == 0">{{row.current_qiye_form_num}}/</span>{{row.current_qiye_threeplus}}</span>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].qiye_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.qiye_form_cost}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="zonghe">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_zonghe_form_num >= row.zonghe_form_num)&&row.zonghe_form_num != 0}">
						<span ><span
								v-if="row.current_zonghe_form_num >= 0 &&row.zonghe_form_num != 0">{{row.current_zonghe_form_num}}/</span><span
								v-if="row.zonghe_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.zonghe_form_num != 0">{{row.zonghe_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<span
								:class="{'check-threeplus-false':row.current_zonghe_form_num < row.zonghe_form_num,'check-threeplus-true': (row.current_zonghe_form_num >= row.zonghe_form_num)&&row.zonghe_form_num != 0}"><span v-if="row.current_zonghe_form_num > 0 &&row.zonghe_form_num == 0">{{row.current_zonghe_form_num}}/</span>{{row.current_zonghe_threeplus}}</span>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].zonghe_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.zonghe_form_cost}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="pyq">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_pyq_form_num >= row.pyq_form_num)&&row.pyq_form_num != 0}">
						<span ><span
								v-if="row.pyq_form_num >= 0 &&row.pyq_form_num != 0">{{row.current_pyq_form_num}}/</span><span
								v-if="row.pyq_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.pyq_form_num != 0">{{row.pyq_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<span
								:class="{'check-threeplus-false':row.current_pyq_form_num < row.pyq_form_num,'check-threeplus-true': (row.current_pyq_form_num >= row.pyq_form_num)&&row.pyq_form_num != 0}"><span v-if="row.current_pyq_form_num > 0 &&row.pyq_form_num == 0">{{row.current_pyq_form_num}}/</span>{{row.current_pyq_threeplus}}</span>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].pyq_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.pyq_form_cost}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="shebao">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_shebao_form_num >= row.shebao_form_num)&&row.shebao_form_num != 0}">

						<span ><span
								v-if="row.current_shebao_form_num != 0 &&row.shebao_form_num != 0">{{row.current_shebao_form_num}}/</span><span
								v-if="row.shebao_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.shebao_form_num != 0">{{row.shebao_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<span
								:class="{'check-threeplus-false':row.current_shebao_form_num < row.shebao_form_num,'check-threeplus-true': (row.current_shebao_form_num >= row.shebao_form_num)&&row.shebao_form_num != 0}"><span v-if="row.current_shebao_form_num > 0 &&row.shebao_form_num == 0">{{row.current_shebao_form_num}}/</span>{{row.current_shebao_threeplus}}</span>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].shebao_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.shebao_form_cost}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="remark">
					<div v-if="tabNum ==1">
						<Input v-if="editStatus ==1" v-model="datas[index].remark">
						</Input>
						<span v-if="editStatus ==0">{{row.remark}}</span>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].remark">
						</Input>
						<span v-if="editStatus ==0">{{row.remark}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="all">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_form_num >= row.demand_form_num)&&row.demand_form_num != 0}">
						<div>
							<span>{{row.current_form_num}}/{{row.demand_form_num}}</span>
						</div>
						<div v-if="checkThreePlusStatus == true">
							<span>{{row.current_all_threeplus}}</span>
						</div>
					</div>

				</template>
			</Table>
		</div>
	</div>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAdvCity,
	} from "../../../api/runSet";
	import {
		getCidTypeList,
		getDamandDataList
	} from "../../../api/advManage";

	export default {
		name: "demand_data",
		props:['date'],
		data() {
			return {
				modal: false,
				name: '',
				tabNum: 1,
				datas: [],
				timePeriod: '7',
				timePeriodDate: [],
				checkThreePlusStatus:false,
				defaultColumns: [{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "总数",
						"slot": "all",
						"align": 'center',
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		watch: {
			date(){
				console.log(this.date)
				this.timePeriodDate[0] = this.date
				this.timePeriodDate[1] = this.date
				this.getList();				
			},
		},
		methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				//拼接表头
				console.log(that.cidTypeList);
				for (let i = 0; i < that.cidTypeList.length; i++) {
					var data1 = {};
					data1.title = that.cidTypeList[i].type;
					if (that.cidTypeList[i].type == "公积金") {
						data1.slot = "gjj";
					} else if (that.cidTypeList[i].type == "车抵贷") {
						data1.slot = "chedi";
					} else if (that.cidTypeList[i].type == "房抵贷") {
						data1.slot = "fangdi";
					} else if (that.cidTypeList[i].type == "企业贷") {
						data1.slot = "qiye";
					} else if (that.cidTypeList[i].type == "综合") {
						data1.slot = "zonghe";
					} else if (that.cidTypeList[i].type == "朋友圈") {
						data1.slot = "pyq";
					} else if (that.cidTypeList[i].type == "社保") {
						data1.slot = "shebao";
					}
					data1.align = "center";
					that.defaultColumns.splice(i + 1, 0, data1); //从数组的第二项开始插入
				}
				this.getList();
			},
			tabClick(e) {
				if (e == "name1") {
					this.tabNum = 1;
				} else if (e == "name2") {
					this.tabNum = 2;
				} else if (e == "name3") {
					this.tabNum = 3;
				}
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getDamandDataList(that, data);
				that.datas = res.data.list;
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #0055ff;
	}

	/deep/ .ivu-table .table-black-row td {
		color: #ffff00;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.first {
		background-color: #d47e83;

		color: #fff;

	}

	.check-threeplus-false {
		color: cornflowerblue;
	}

	.check-threeplus-true {
		color: #fff;
	}

	.second {

		background-color: #277dd3;

		color: #fff;

	}
</style>
